<template>
    <div
        class="modal fade"
        id="bestiaryAttackCompendiumModal"
        tabindex="-1"
        aria-hidden="true"
        ref="modal"
    >
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content bg-dark text-light rounded-3 shadow-lg">
                <div class="modal-header">
                    <h4 class="modal-title">
                        {{
                            mode === "add"
                                ? "Add Bestiary Attack"
                                : "Edit Bestiary Attack"
                        }}
                    </h4>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                    ></button>
                </div>

                <div class="modal-body">
                    <!-- Edit: pick existing -->
                    <div v-if="mode === 'edit'" class="input-group mb-3">
                        <span class="input-group-text">Select Attack</span>
                        <select
                            v-model="selectedName"
                            @change="loadAttack"
                            class="form-select"
                        >
                            <option disabled value="">Select...</option>
                            <option
                                v-for="atk in store.bestiaryAttacks.sort(
                                    (a, b) => a.name.localeCompare(b.name)
                                )"
                                :key="atk.name"
                                :value="atk.name"
                            >
                                {{ atk.name }}
                            </option>
                        </select>
                    </div>

                    <!-- Attack form -->
                    <div class="input-group mb-3">
                        <span class="input-group-text">Name</span>
                        <input v-model="attack.name" class="form-control" />
                    </div>

                    <div class="input-group mb-3">
                        <span class="input-group-text">Description</span>
                        <textarea
                            v-model="attack.description"
                            class="form-control"
                        ></textarea>
                    </div>

                    <div class="input-group mb-3">
                        <span class="input-group-text">Damage</span>
                        <input v-model="attack.damage" class="form-control" />
                    </div>

                    <div class="input-group mb-3">
                        <span class="input-group-text">Range</span>
                        <input v-model="attack.range" class="form-control" />
                    </div>

                    <div class="input-group mb-3">
                        <span class="input-group-text">Archetype</span>
                        <select
                            v-model="attack.archetype"
                            class="form-control"
                        >
                            <option value="grit">Grit</option>
                            <option value="wit">Wit</option>
                            <option value="smarts">Smarts</option>
                            <option value="heart">Heart</option>
                            <option value="luck">Luck</option>
                            <option value="strange">Strange</option>
                        </select>
                    </div>
                </div>

                <p class="px-3">
                    <strong>
                        Note: These changes won't affect any monsters already
                        added. Remove & re-add them to apply changes.
                    </strong>
                </p>

                <div class="modal-footer">
                    <button class="btn btn-secondary" data-bs-dismiss="modal">
                        <font-awesome-icon icon="multiply" class="me-1" /> Close
                    </button>
                    <button
                        v-if="mode === 'edit'"
                        class="btn btn-danger me-1"
                        @click="deleteAttack"
                    >
                        <font-awesome-icon icon="trash-alt" class="me-1" />
                        Delete
                    </button>
                    <button class="btn btn-primary" @click="saveAttack">
                        <font-awesome-icon icon="save" class="me-1" /> Save
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useRosterStore } from "@/stores/index";

export default {
    name: "BestiaryAttackCompendiumModal",
    props: { mode: { type: String, default: "add" } },
    data() {
        return {
            store: useRosterStore(),
            selectedName: "",
            attack: {
                name: "",
                description: "",
                damage: "",
                range: "",
                archetype: "",
            },
        };
    },
    mounted() {
        this.$refs.modal.addEventListener("show.bs.modal", () => {
            this.resetForm();
        });
    },
    methods: {
        resetForm() {
            this.selectedName = "";
            this.attack = {
                name: "",
                description: "",
                damage: "",
                range: "",
                archetype: "",
            };
        },
        loadAttack() {
            const found = this.store.bestiaryAttacks.find(
                (a) => a.name === this.selectedName
            );
            if (found) this.attack = JSON.parse(JSON.stringify(found));
        },
        saveAttack() {
            if (!this.attack.name.trim()) {
                alert("Attack must have a name!");
                return;
            }
            if (this.mode === "add") {
                this.store.bestiaryAttacks.push(this.attack);
                alert(`Added attack "${this.attack.name}"`);
            } else {
                const idx = this.store.bestiaryAttacks.findIndex(
                    (a) => a.name === this.selectedName
                );
                if (idx !== -1)
                    this.store.bestiaryAttacks.splice(idx, 1, this.attack);
                alert(`Updated attack "${this.attack.name}"`);
            }
            this.resetForm();
        },
        deleteAttack() {
            if (!this.selectedName) return;
            if (confirm(`Delete attack "${this.selectedName}"?`)) {
                const idx = this.store.bestiaryAttacks.findIndex(
                    (a) => a.name === this.selectedName
                );
                if (idx !== -1) this.store.bestiaryAttacks.splice(idx, 1);
                alert(`Deleted attack "${this.selectedName}"`);
                this.resetForm();
            }
        },
    },
};
</script>

